import { useTranslation } from 'react-i18next';
import { S, Icon, Icons, BtnPrimary, BtnSecondary } from '../regureStyles';
import PermissionGate from '../../components/PermissionGate';

const Header = ({ setShowAddForm }) => {
  const { t } = useTranslation();
  return (
    <header
      style={{
        padding: '20px 32px',
        borderBottom: `1px solid ${S.borderLight}`,
        background: 'rgba(255,255,255,0.85)',
        backdropFilter: 'blur(20px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <div>
        <div style={{ fontSize: 12, color: S.textMuted, display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
          {t('screens.brokers.breadcrumb')} {Icons.chevronRight(S.textMuted, 12)} <span style={{ color: S.textPrimary, fontWeight: 500 }}>{t('nav.brokers')}</span>
        </div>
        <div style={{ fontSize: 22, fontWeight: 700, color: S.textPrimary }}>{t('screens.brokers.title')}</div>
      </div>
      <div style={{ display: 'flex', gap: 10 }}>
        <PermissionGate resource='brokers' action='create'>
          <BtnPrimary onClick={() => setShowAddForm(true)}>
            <Icon name='plus' color='#fff' size={16} /> {t('screens.brokers.addBroker')}
          </BtnPrimary>
        </PermissionGate>
        <BtnSecondary>
          <Icon name='download' color={S.textMuted} size={15} /> {t('screens.brokers.export')}
        </BtnSecondary>
      </div>
    </header>
  );
};

export default Header;
